import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, {
    EndpointQueryParameters,
    StrapiCreate,
    StrapiSingle,
    StrapiUpdate,
} from '../../types/strapi/strapi'
import StampOrder from '../../types/api/stamp-order'
import getQuery from '../../helpers/api/get-query'

export const stampOrdersApi = createApi({
    reducerPath: 'stampOrdersApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Stamps'],
    endpoints: builder => ({
        getStampOrders: builder.query<Strapi<StampOrder>, EndpointQueryParameters | void>({
            query: getQuery('/stamp-orders'),
        }),
        getStampOrderByDocId: builder.query<
            StrapiSingle<StampOrder>,
            [string, EndpointQueryParameters | void]
        >({
            query: ([docId, params]) => getQuery(`/stamp-orders/${docId}`)(params),
        }),
        createStampOrder: builder.mutation<StrapiSingle<StampOrder>, StrapiCreate<StampOrder>>({
            query: body => ({
                url: '/stamp-orders',
                method: 'POST',
                body,
            }),
        }),
        updateStampOrder: builder.mutation<StrapiSingle<StampOrder>, StrapiUpdate<StampOrder>>({
            query: ({ docId, body }) => ({
                url: `/stamp-orders/${docId}?populate=*`, // принудительный populate чтобы ответ приходил с данными о связях
                method: 'PUT',
                body,
            }),
        }),
        getLastStampOrderByStamp: builder.query<Strapi<StampOrder>, string>({
            query: stampNumber => `/stamp-orders?filters[stamp][documentId][$eq]=${stampNumber}`, // TODO: добавить сортировку!!!!
        }),
    }),
})

export const {
    useGetStampOrdersQuery,
    useGetStampOrderByDocIdQuery,
    useLazyGetLastStampOrderByStampQuery,

    useCreateStampOrderMutation,
    useUpdateStampOrderMutation,
} = stampOrdersApi
